import { getUsers as getUsersFirestore } from '../utils/firestoreUtils';
import { auth } from './firebase/config';

// Délai simulé pour imiter les appels réseau
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Mode développement (pour simuler des données sans appeler l'API)
const DEV_MODE = false;

// Fonction utilitaire pour gérer les erreurs d'authentification
const handleAuthError = async (error, operation, retryFn) => {

  // Vérifier si c'est une erreur d'authentification
  if ((error.code && (error.code === 'permission-denied' || error.code === 'unauthenticated')) || 
      (error.message && (error.message.includes('permission-denied') || 
                         error.message.includes('unauthenticated') || 
                         error.message.includes('Utilisateur non authentifié')))) {

    // Tenter de récupérer le contexte d'authentification
    if (typeof window !== 'undefined' && window.__authContext) {
      try {
        const refreshFn = window.__authContext.refreshFirebaseToken;
        if (typeof refreshFn === 'function') {
          const refreshed = await refreshFn();
          
          if (refreshed) {
            if (typeof retryFn === 'function') {
              // Réessayer l'opération originale
              return await retryFn();
            }
          } else {

            // Stocker un flag pour informer l'application du problème
            localStorage.setItem('auth_refresh_failed', 'true');
          }
        } else {

        }
      } catch (refreshError) {

      }
    } else {

      // Flag pour indiquer un besoin de reconnexion
      localStorage.setItem('auth_refresh_needed', 'true');
    }
  }
  
  // Si le rafraîchissement a échoué ou ce n'était pas une erreur d'authentification
  throw error;
};

// Service pour les utilisateurs
const userService = {
  // Rechercher des utilisateurs pour l'autocomplétion
  searchUsers: async (searchTerm = '') => {
    const retryOperation = async () => userService.searchUsers(searchTerm);
    
    try {
      // En mode développement, retourner des données mockées
      if (DEV_MODE) {
        await delay(300); // Simuler un délai réseau
        
        // Utilisateurs mockés
        const mockUsers = [
          { id: 'user1', displayName: 'Jean Dupont', title: 'Développeur', email: 'jean.dupont@example.com' },
          { id: 'user2', displayName: 'Marie Martin', title: 'Chef de projet', email: 'marie.martin@example.com' },
          { id: 'user3', displayName: 'Pierre Durand', title: 'Designer', email: 'pierre.durand@example.com' },
          { id: 'user4', displayName: 'Sophie Bernard', title: 'Marketing', email: 'sophie.bernard@example.com' },
          { id: 'user5', displayName: 'Thomas Petit', title: 'Commercial', email: 'thomas.petit@example.com' },
        ];
        
        if (!searchTerm) {
          return mockUsers;
        }
        
        // Filtrer les utilisateurs mockés selon le terme de recherche
        const searchTermLower = searchTerm.toLowerCase();
        return mockUsers.filter(user => 
          user.displayName.toLowerCase().includes(searchTermLower) ||
          user.email.toLowerCase().includes(searchTermLower) ||
          (user.title && user.title.toLowerCase().includes(searchTermLower))
        );
      }

      // Vérifier si l'utilisateur est authentifié
      if (!auth.currentUser) {
        throw new Error('Utilisateur non authentifié');
      }
      
      // Récupérer les utilisateurs depuis Firestore
      return await getUsersFirestore(searchTerm);
    } catch (error) {
      try {
        // Essayer de gérer l'erreur d'authentification
        return await handleAuthError(error, 'recherche d\'utilisateurs', retryOperation);
      } catch (finalError) {

        return [];
      }
    }
  }
};

export default userService; 